import { HttpErrorResponse } from '@angular/common/http';

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof HttpErrorResponse) {
    return error.error?.message || error.message || $localize`HTTP error occurred`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return $localize`An unexpected error occurred`;
};
